export default __webpack_public_path__ + "static/media/Hydrological_Drought.17941579.webp";